module.exports = __webpack_public_path__ + "lato-regular-webfont.de23321870f3010fb26c.ttf";


//////////////////
// WEBPACK FOOTER
// C:/WS/Fusion/FusionDashboard/resources/fonts/lato-regular-webfont.ttf
// module id = ../../../../../resources/fonts/lato-regular-webfont.ttf
// module chunks = styles